var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "star-half_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06.945c.193-.593 1.033-.593 1.225 0l1.413 4.346a.644.644 0 00.612.445h4.57c.624 0 .883.799.379 1.166l-3.697 2.686a.644.644 0 00-.234.72l1.412 4.346c.192.593-.487 1.087-.992.72l-3.697-2.686a.644.644 0 00-.757 0l-3.697 2.686c-.505.367-1.184-.127-.991-.72l1.412-4.346a.644.644 0 00-.234-.72L1.087 6.902c-.505-.367-.245-1.166.379-1.166h4.57c.278 0 .526-.18.612-.445L8.06.945z",
    fill: "#D7DDE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#star-half_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06.945c.193-.593 1.033-.593 1.225 0l1.413 4.346a.644.644 0 00.612.445h4.57c.624 0 .883.799.379 1.166l-3.697 2.686a.644.644 0 00-.234.72l1.412 4.346c.192.593-.487 1.087-.992.72l-3.697-2.686a.644.644 0 00-.757 0l-3.697 2.686c-.505.367-1.184-.127-.991-.72l1.412-4.346a.644.644 0 00-.234-.72L1.087 6.902c-.505-.367-.245-1.166.379-1.166h4.57c.278 0 .526-.18.612-.445L8.06.945z",
    fill: "#D7DDE4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F66CB",
    d: "M0 1h11v14H0z"
  }))));
}
export default SvgStarHalf;